export default __webpack_public_path__ + "static/media/img-banner05.c7ea5915.png";